var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.3527 0.602252C9.24721 0.496763 9.10413 0.4375 8.95495 0.4375C8.80576 0.4375 8.66269 0.496763 8.5572 0.602252L1.66291 7.49654C1.59224 7.56721 1.54168 7.65543 1.51642 7.75213L0.766417 10.6235C0.71595 10.8167 0.771704 11.0222 0.91291 11.1634C1.05412 11.3046 1.2596 11.3603 1.45282 11.3099L4.32413 10.5599C4.42083 10.5346 4.50906 10.484 4.57973 10.4134L11.474 3.51907C11.6937 3.2994 11.6937 2.94324 11.474 2.72357L9.3527 0.602252ZM2.56633 8.18412L8.95495 1.7955L10.2808 3.12132L3.89215 9.50994L2.09758 9.97869L2.56633 8.18412Z",
    fill: "#414141"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 12.4375C0.68934 12.4375 0.4375 12.6893 0.4375 13C0.4375 13.3107 0.68934 13.5625 1 13.5625H12.25C12.5607 13.5625 12.8125 13.3107 12.8125 13C12.8125 12.6893 12.5607 12.4375 12.25 12.4375H1Z",
    fill: "#414141"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/editIcon.211949c8aaae60dce955a9f6a54756a0.svg";
export { ForwardRef as ReactComponent };